import __json from '../config/currency.json';

type DataFromJson = {
	countries: Readonly<Record<string, string>>;
	stripe: {
		unsupported: readonly string[];
	};
};

export const data: DataFromJson = __json;
